import React from 'react';

import styles from './fixed-sidebar.scss';

interface Props {
  children: any;
}

const FixedSidebar = ({ children }: Props) => {
  return (
    <div className={styles.fixedSidebar} data-hook="fixed-sidebar">
      {children}
    </div>
  );
};

export default FixedSidebar;
